import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { removeItemFromArray } from '@shared';
import { IUserRole, RoleType } from '@account-users/user/models/UserRole';
import { Permission } from '@account-users/account/models/Permission';

@Component({
  selector: 'app-user-role-search',
  templateUrl: './user-role-search.component.html',
  styleUrls: ['./user-role-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserRoleSearchComponent {
  @Input() userRolesSearch: string[] = [];
  @Input() userRolesArray: IUserRole[] = [];
  @Input() userPermissions: Permission[] = [];
  @Input() roleType = '';

  @Output() search: EventEmitter<any> = new EventEmitter();

  roleTypes = RoleType;
  currentRoleFilters: string[] = [];

  toggleFilter(role: string): void {
    this.currentRoleFilters = this.currentRoleFilters.includes(role)
      ? removeItemFromArray(this.currentRoleFilters, role)
      : [...this.currentRoleFilters, role];

    this.search.emit(this.currentRoleFilters);
  }

  get userRoles() {
    const canFilterAdmins = this.userPermissions.includes(Permission.CanAddSU);
    return canFilterAdmins
      ? this.userRolesArray
      : this.userRolesArray.filter(({ code }) => code !== 'Owner');
  }
}
